// Appareil tactile principal ou PWA installée : seuls cas où le verrou Face ID a du sens.
export function isMobileDevice() {
  try {
    if (typeof window === 'undefined') return false;
    if (window.navigator?.standalone === true) return true;
    if (typeof window.matchMedia !== 'function') return false;
    return (
      window.matchMedia('(pointer: coarse)').matches ||
      window.matchMedia('(display-mode: standalone)').matches
    );
  } catch {
    return false;
  }
}
